<template>
  <!--
    Triggered when clicking on the "close" button
    @event close
  -->
  <!--
    Triggered when clicking on "Cancel"
    @event reject
  -->
  <!--
    Triggered when clicking on "OK"
    @event accept
  -->
  <rui-modal :caption="displayTitle"
             :closeable="closeable"
             :acceptable="acceptable"
             :cancellable="rejectable"
             @close="$emit('close')"
             @accept="$emit('accept')"
             @cancel="$emit('reject')">
    <slot><div class="_container -mvd">{{ message }}</div></slot>
  </rui-modal>
</template>

<script>
import RuiModal from './Modal.vue'

/**
 * Confirm dialog with custom text and actions
 *
 * This is only a modal component with some defaults.
 *
 * @noPlayground Some setup is needed to be able to show/hide the component
 * @propsGroup Behavior [closeable, acceptable, rejectable]
 * @propsGroup Content  [message, caption]
 */
export default {
  name: 'RuiConfirmDialog',
  emits: [
    'close',
    'accept',
    'reject',
  ],
  components: { RuiModal },
  props: {
    /** Message to display */
    message: { required: false, type: String, default: null },
    /** Modal caption */
    caption: { required: false, type: String, default: null },
    /** Whether to add a "close" button */
    closeable: { required: false, type: Boolean, default: false },
    /** Whether to add an "Ok" button */
    acceptable: { required: false, type: Boolean, default: true },
    /** Whether to add a "Cancel" button */
    rejectable: { required: false, type: Boolean, default: true },
  },
  data () {
    return { displayTitle: this.$props.caption || this.$t('rui.confirm_dialog.are_you_sure') }
  },
}
</script>
